import React, {useEffect} from 'react'
import {useIsAuthenticated, useMsal, useMsalAuthentication} from '@azure/msal-react'
import Spinner from 'react-bootstrap/Spinner';
import {useDispatch, useSelector} from 'react-redux';
import {InteractionType} from "@azure/msal-browser";
import {requestUserInformation} from '../../helpers/reduxstore/reducers/userReducer.js';
import * as Sentry from "@sentry/react";
import {getCurrentHub} from "@sentry/react";
import {getGroupsWithDevices} from "../../helpers/reduxstore/reducers/groupReducer.js";
import {getCustomerFirmwareUpdates} from "../../helpers/reduxstore/reducers/customerFirmwareUpdatesReducer.js";
import {msalInstance} from "../../api/api.js";

export default function AuthTemplate({children}) {
    const dispatch = useDispatch()
    useMsalAuthentication(InteractionType.Redirect, ["User.Read"])
    const isAuthenticated = useIsAuthenticated();
    const {accounts} = useMsal();

    useEffect(() => {
        if (accounts.length > 0) {
            msalInstance.handleRedirectPromise().then(res => {
                if (res) console.log("msalInstance.handleRedirectPromise detected redirect")
            })

            msalInstance.setActiveAccount(accounts[0]);

            dispatch(requestUserInformation())
            dispatch(getGroupsWithDevices())
            dispatch(getCustomerFirmwareUpdates())
        }
    }, [accounts, dispatch]);

    // Polling for groups/devices every 30 seconds when authenticated
    useEffect(() => {
        if (isAuthenticated) {
            const interval = setInterval(() => {
                dispatch(getGroupsWithDevices());
                dispatch(getCustomerFirmwareUpdates());
            }, 120000); // 2 min
            return () => clearInterval(interval);
        }
    }, [isAuthenticated, dispatch]);

    const {user} = useSelector(state => state.user);
    useEffect(() => {
        Sentry.setUser({
            id: user.id,
            email: user.mail,
            ip_address: "{{auto}}"
        });

        const client = getCurrentHub().getClient();
        const options = client?.getOptions();
        if (!options.replaysSessionSampleRate && user.mail) {
            console.log(`Enabling sentry replay for user ${user.mail}`)

            options.replaysSessionSampleRate = 0.1;
            options.replaysOnErrorSampleRate = 1;

            const replay = new Sentry.Replay({
                maskAllInputs: false,
                maskAllText: false,
                blockAllMedia: false
            })

            client?.addIntegration?.(replay);
        }
    }, [user])

    return (
        <React.Fragment>
            {isAuthenticated && (
                <div>
                    {children}
                </div>
            )}
            {!isAuthenticated && (
                <div className="spinner-wrapper">
                    <Spinner animation="border" variant="primary" size="md" className="d-inline-block"/>
                    <h4 className="ml-2 d-inline-block text-primary ms-3">Authentication in process.. </h4>
                </div>
            )}
        </React.Fragment>
    )
}